(function($) {
    $('.menu-toggle').click(function(e) {
        if ($('#mobile-navigation').hasClass('open')) {
            $('#mobile-navigation').removeClass('open');
        } else {
            $('#mobile-navigation').addClass('open');
        }
    });

    $('.category-filter').hover(function(e) {
        $('.category-filter ul.categories').fadeIn();
    }, function () {
        $('.category-filter ul.categories').fadeOut();
    });

    $('.category-filter .title').click(function(e) {
        if ($('.category-filter ul.categories').css('display') == 'none') {
            $('.category-filter ul.categories').fadeIn();
        } else {
            $('.category-filter ul.categories').fadeOut();
        }
    });

})( jQuery );
